var map = {
	"./avatar.svg": 8774,
	"./b-arrow.svg": 9145,
	"./card.svg": 1057,
	"./cashier.svg": 1000,
	"./close.svg": 1169,
	"./closefull.svg": 522,
	"./coach.svg": 391,
	"./community.svg": 4090,
	"./coupon.svg": 9477,
	"./course.svg": 1350,
	"./dashboard.svg": 8413,
	"./data.svg": 7725,
	"./delete.svg": 7537,
	"./device.svg": 3056,
	"./edit.svg": 9692,
	"./example.svg": 457,
	"./eye-open.svg": 9290,
	"./eye.svg": 7223,
	"./form.svg": 533,
	"./full.svg": 7555,
	"./hidden_menu.svg": 6312,
	"./income.svg": 3483,
	"./language.svg": 8331,
	"./link.svg": 3803,
	"./mec.svg": 6225,
	"./message.svg": 9876,
	"./nested.svg": 1194,
	"./order.svg": 3189,
	"./password.svg": 5055,
	"./qrshared.svg": 1432,
	"./refund.svg": 5873,
	"./report.svg": 8883,
	"./search.svg": 8236,
	"./share.svg": 3739,
	"./share_link.svg": 749,
	"./shop.svg": 3698,
	"./show_menu.svg": 781,
	"./staff.svg": 9181,
	"./stat.svg": 6297,
	"./student.svg": 5046,
	"./table.svg": 9581,
	"./teaching.svg": 5406,
	"./tree.svg": 892,
	"./user.svg": 9814,
	"./venue.svg": 1970,
	"./venue_buy.svg": 4605,
	"./venue_buy2.svg": 7746,
	"./venue_buy3.svg": 7006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3573;